export const SEARCH_ERROR_MESSAGES = {
  auth: "Authentication required",
  nlSearchNotConfigured:
    "Natural-language search isn't configured here. Build the search with the data catalog instead: the grid icon in the search bar.",
  searchParametersError: "Search parameters error",
  unexpected: "An unknown error occurred",
};

const SEARCH_ERRORS = {
  // The parameters route's 503 when there's no OPENAI_API_KEY in this environment.
  NL_SEARCH_NOT_CONFIGURED: SEARCH_ERROR_MESSAGES.nlSearchNotConfigured,
  SEARCH_PARAMETERS_ERROR: SEARCH_ERROR_MESSAGES.searchParametersError,
};

/**
 * Picks the user-facing message for a failure. `status` is the HTTP status (absent for a stream
 * event or a request that never got a response), `code` the API error code when there is one.
 */
export function getSearchErrorMessage({ status, code } = {}) {
  if (code && SEARCH_ERRORS[code]) return SEARCH_ERRORS[code];
  if (status === 401) return SEARCH_ERROR_MESSAGES.auth;
  return SEARCH_ERROR_MESSAGES.unexpected;
}
